import React from "react";
import Button from "@material-ui/core/Button";

import positionNavButton from "./positionNavButton";

import styled, { css } from "styled-components";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

import Link from "../../components/Link/Link";
import { useState, useEffect } from "react";

const PosBack = styled.div`
  ${positionNavButton}

  ${({ align }) =>
    align === "right" &&
    css`
      right: 5vmin;
    `}

    ${({ align }) =>
      align === "left" &&
      css`
        left: 5vmin;
      `}
`;

export default function NavButtonBottom() {
  const pagesArray = [
    "/",
    "/projects",
    "/work",
    "/education",
    "/contact",
    "/skills"
  ];

  //for next;
  const [currentPage, setCurrentPage] = useState("/projects");
  const [count, setCount] = useState(1);

  // for back
  const [currentPageBack, setCurrentPageBack] = useState("/");
  const [countBack, setCountBack] = useState(0);

  useEffect(() => {
    if (count >= 5) {
      setCurrentPage("/skills");
      setCount(5);
    } else if (countBack <= 0) {
      setCurrentPageBack("/");
      setCountBack(0);
    }
  });

  function next() {
    setCurrentPage(pagesArray[count + 1]);
    setCount(count + 1);
    setCurrentPageBack(pagesArray[count - 1]);
    setCountBack(count - 1);
  }

  function back() {
    setCurrentPageBack(pagesArray[countBack - 1]);
    setCountBack(countBack - 1);
    setCurrentPage(pagesArray[countBack + 1]);
    setCount(countBack + 1);
  }
  return (
    <>
      <PosBack align="left">
        <Link to={currentPageBack} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary" onClick={back}>
            <ArrowBackIcon />
            &emsp; Back
          </Button>
        </Link>
      </PosBack>
      <PosBack align="right">
        <Link to={currentPage} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary" onClick={next}>
            Next &emsp;
            <ArrowForwardIcon />
          </Button>
        </Link>
      </PosBack>
    </>
  );
}
